import { ISuperTableComponentRowFormValue } from './super-table-component-row-form-value.interface';

export interface ISuperTableComponentFormValue {
    tableTitle: string;
    rows: ISuperTableComponentRowFormValue[];
    compareYears: boolean;
    transpose: boolean;
    showPreviousYear: boolean;
    footnote: string;
}
